import { inject, provideEnvironmentInitializer } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

const SELF_SIZED_PANELS = [
  'purchase-flow-dialog-panel',
  'talk-to-sales-dialog-panel',
  'renewal-dialog-panel',
  'welcome-back-dialog-panel',
];

const DIALOG_MAX_HEIGHT = '92vh';

function findPane(ref: MatDialogRef<unknown>): HTMLElement | null {
  const host = ref.componentRef?.location.nativeElement as HTMLElement | undefined;
  const pane = host?.closest<HTMLElement>('.cdk-overlay-pane');
  if (pane) return pane;

  const containers = document.querySelectorAll('mat-dialog-container');
  return containers[containers.length - 1]?.closest<HTMLElement>('.cdk-overlay-pane') ?? null;
}

function applyAdaptiveSize(pane: HTMLElement): void {
  if (SELF_SIZED_PANELS.some(cls => pane.classList.contains(cls))) return;

  const { height, minHeight, maxHeight } = pane.style;
  const isSet = (value: string) => !!value && value !== 'auto' && value !== 'none';

  pane.style.setProperty('--dialog-height', isSet(height) ? height : 'auto');
  const floor = isSet(minHeight) ? minHeight : isSet(height) ? height : '0px';
  pane.style.setProperty('--dialog-min-height', floor);
  pane.style.setProperty(
    '--dialog-max-height',
    isSet(maxHeight) ? `min(${maxHeight}, ${DIALOG_MAX_HEIGHT})` : DIALOG_MAX_HEIGHT
  );
  pane.classList.add('adaptive-dialog');
}

export const provideAdaptiveDialogs = () =>
  provideEnvironmentInitializer(() => {
    inject(MatDialog).afterOpened.subscribe(ref => {
      const pane = findPane(ref);
      if (pane) applyAdaptiveSize(pane);
    });
  });
